/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum IMooringType {
    Barge = 0,
    SteelCage = 1,
    LadderCage = 2,
    FrameCage = 3,
}
